import { IReferenceDto } from './fileConfig'
import { UserListItemDto } from './userConfig'

export interface TaskOverviewDto {
    id: string
    status: TaskStatus
    description: string
    file: IReferenceDto
    due: string
    assignee: UserListItemDto
    assigner: UserListItemDto
    attachmentIds: string[]
}

export interface TaskMutationDto {
    status: TaskStatus
    description: string
    due: string
    fileId: string
    assigneeId: string
    assignerId: string
    attachmentIds: string[]
}

export enum TaskStatus {
    Open = 'OPEN',
    Finished = 'FINISHED',
}

export enum TaskAction {
    GetOverview = 'GET_TASK_OVERVIEW',
    Add = 'ADD_TASK',
    Update = 'UPDATE_TASK',
    Toggle = 'TOGGLE_TASK',
    Delete = 'DELETE_TASK',
    ResetOverview = 'RESET_TASK_OVERVIEW',
    OverviewSettings = 'TASK_OVERVIEW_SETTINGS',
}
